const getPaginationTotalLength = (total, pageSize) => {
  return Math.ceil(total / pageSize)
}

export default getPaginationTotalLength
